const PUBLIC_KEY = "pk_test_b16f775a67c780753bae2872a4041c3b56eb03d5";
// const PUBLIC_KEY = "pk_live_712332318f9883cc97fda53fda3b545fddd78bfa";

// const I0_LINK = "http://127.0.0.1:3500";
// const I0_LINK = "https://farmyapp.onrender.com"
const I0_LINK = "https://farmyappbackend.onrender.com";
//
export { I0_LINK, PUBLIC_KEY };
